import type { NotificationCategory } from '@/types/notificationPreferences/types';

export const CATEGORY_LABEL: Record<NotificationCategory, string> = {
  PETICIONAMENTO: 'Peticionamento',
  EXTRAJUDICIAL: 'Extrajudicial',
  NEGOCIACAO: 'Negociação',
  ANDAMENTO_PROCESSO: 'Andamento de processo',
  INTIMACAO: 'Intimação',
  ASSINATURA: 'Assinatura',
  SISTEMA: 'Sistema',
};

export const CATEGORY_DESCRIPTION: Record<NotificationCategory, string> = {
  PETICIONAMENTO: 'Pedidos de assinatura, status de petições, prazos.',
  EXTRAJUDICIAL: 'Lotes de notificação extrajudicial, entregas.',
  NEGOCIACAO: 'Propostas, contrapropostas, acordos fechados.',
  ANDAMENTO_PROCESSO: 'Novas movimentações nos processos que você acompanha.',
  INTIMACAO: 'Intimações recebidas via monitoramento.',
  ASSINATURA: 'Convites de assinatura, expiração próxima, conclusão.',
  SISTEMA: 'Convites para escritórios, mudanças de papel, avisos da plataforma.',
};

export const CATEGORIES: readonly NotificationCategory[] = [
  'ASSINATURA',
  'INTIMACAO',
  'PETICIONAMENTO',
  'NEGOCIACAO',
  'EXTRAJUDICIAL',
  'ANDAMENTO_PROCESSO',
  'SISTEMA',
];
